import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

const sizeMaps = {
  xsmall: 2.5,
  small: 3.5,
  normal: 5,
  large: 7.5,
  xlarge: 10,
};

export const avatar = (theme: Theme) => css`
  position: relative;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  background-color: ${theme.system.borderHover};
  color: ${theme.text.onBackground};
`;

export const isLight = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMutedHover};
  color: ${theme.text.subdued};
`;

export const image = css`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const overlayChip = css`
  position: absolute;
  font-size: initial;
`;

export const overlayPosition = {
  topRight: size => css`
    --translate: calc(calc(${sizeMaps[size]}rem * 0.3) + 0.5rem);
    transform: translate(var(--translate), calc(var(--translate) * -1));
  `,
  topLeft: size => css`
    --translate: calc(calc(calc(${sizeMaps[size]}rem * 0.3) + 0.5rem) * -1);
    transform: translate(var(--translate), var(--translate));
  `,
  bottomLeft: size => css`
    --translate: calc(calc(${sizeMaps[size]}rem * 0.3) + 0.5rem);
    transform: translate(calc(var(--translate) * -1), var(--translate));
  `,
  bottomRight: size => css`
    --translate: calc(calc(${sizeMaps[size]}rem * 0.3) + 0.5rem);
    transform: translate(var(--translate), var(--translate));
  `,
  center: () => css`
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
  `,
};

export const sizes = {
  xsmall: css`
    height: ${sizeMaps.xsmall}rem;
    width: ${sizeMaps.xsmall}rem;
    font-size: ${typography.bodyFontSize};
  `,
  small: css`
    height: ${sizeMaps.small}rem;
    width: ${sizeMaps.small}rem;
    font-size: ${typography.bodyFontSize};
  `,
  normal: css`
    height: ${sizeMaps.normal}rem;
    width: ${sizeMaps.normal}rem;
    font-size: ${typography.h3FontSize};
  `,
  large: css`
    height: ${sizeMaps.large}rem;
    width: ${sizeMaps.large}rem;
    font-size: ${typography.h2FontSize};
  `,
  xlarge: css`
    height: ${sizeMaps.xlarge}rem;
    width: ${sizeMaps.xlarge}rem;
    font-size: ${typography.h1FontSize};
  `,
};
